import React, { useEffect, useLayoutEffect, useState } from "react";
import * as Styled from "./styles";
import SideMenu from "./SideMenu";
import WheelHeader from "../../../WheelHeader";
import { ASSETS } from "../../../../utils/config";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsWheelSavingLoader,
  getSubTitle,
  getWheelAutoResizing,
  getWheelName,
  getWheelSegments,
} from "../../../../redux/selectors/segmentBuilderSelectors";
import { Description, Save, View } from "../../../../assets/icons";
import SocialFoxFeedbackForm from "../../../SocialFoxFeedbackForm";
import FeedbackIcon from "../../../../assets/icons/Social/Feedback";
import styles from "./field.scss";
import TextView from "../../../TextView";
import BroadCastButton from "../../../LiveCloneComponents/BroadCastButton";
import { useEditor } from "@craftjs/core";
import {
  pushToHistoryAction,
  setContentHeights,
  setWheelSegments,
} from "../../../../redux/reducers/segmentBuilder";
import { DATA_MULTIPLIER } from "../SegmentsTab";
import {
  countAllNodes,
  countTextCharacters,
  segmentsAreSame,
} from "../SegmentsTab/SegmentsTabHelpers";
import { charLimitInASegment } from "../../../SegmentSettings";

function WheelLayout({
  handleSaveWheel = () => {},
  children,
  setModalOpen,
  setOnLeave,
  onClickBeta = () => {},
  isAutoSaving,
  setIsAutoSaving,
  isAutoSaveError,
  unsavedChanges,
  onBroadCastPress = () => {},
  handleLogoClick = () => {},
  isEditScreen,
  hasCharLimitExceeded = false,
}) {
  const dispatch = useDispatch();

  const wheel_name = useSelector(getWheelName);
  const sub_title = useSelector(getSubTitle);
  const { id } = useParams();
  const nav = useNavigate();
  const isWheelSaving = useSelector(getIsWheelSavingLoader);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);

  const wheelData = useSelector(getWheelSegments);
  const automaticResizing = useSelector(getWheelAutoResizing);

  // const handleAutoResizeByContent = () => {
  //   if (!wheelData || wheelData.length === 0) return;

  //   // 1) measure each segment's contentHeight
  //   let newHeights = { ...contentHeights };
  //   let totalHeight = 0;

  //   const measuredSegments = wheelData.map((seg) => {
  //     // Attempt measurement
  //     const measuredVal = tryMeasureSegment(seg, query);
  //     // console.log(measuredVal, "CORR TRY", seg.settings?.id || seg.id);
  //     const baseId = seg.settings?.id || seg.id;
  //     if (measuredVal && measuredVal > 0) {
  //       // store newly measured height
  //       newHeights[baseId] = measuredVal;
  //     }

  //     const knownHeight = newHeights[baseId] || 1; // fallback to 1
  //     totalHeight += knownHeight;
  //     return {
  //       ...seg,
  //       content_height: knownHeight,
  //     };
  //   });

  //   // avoid dividing by zero
  //   if (totalHeight < 1) {
  //     totalHeight = 1;
  //   }

  //   // 2) convert each contentHeight to fraction => *100 => new percentage
  //   const updated = measuredSegments.map((seg) => {
  //     const ratio = seg.content_height / totalHeight;
  //     const newVal = ratio * 100; // distribute 100% by ratio
  //     return { ...seg, value: newVal };
  //   });

  //   let totalData = wheelData.reduce((sum, s) => sum + s.data_value, 0);

  //   const finalSegments = updated.map((seg) => {
  //     const newDataValue = (seg.value / 100) * totalData * DATA_MULTIPLIER;
  //     return {
  //       ...seg,
  //       data_value: Math.max(1, Math.floor(newDataValue)), // keep it integer
  //     };
  //   });

  //   if (!segmentsAreSame(finalSegments, wheelData)) {
  //     // console.log(
  //     //   measuredSegments,
  //     //   "Corr UPDATE",
  //     //   finalSegments,
  //     //   totalHeight,
  //     //   newHeights
  //     // );
  //     dispatch(setWheelSegments(finalSegments));
  //     dispatch(pushToHistoryAction());
  //   }

  //   dispatch(setContentHeights(newHeights));
  // };

  const handleAutoResizeByNodeCount = () => {
    if (!wheelData || wheelData.length === 0) return;

    // 1) Count code blocks (including nested) by traversing seg.nodes
    let totalNodeCount = 0;
    const segmentsWithCounts = wheelData.map((seg) => {
      const nodeMap =
        typeof seg.nodes === "string" ? JSON.parse(seg.nodes) : seg.nodes;
      const nodeCount = countAllNodes(nodeMap, "ROOT");
      console.log(nodeCount, "CORR COUNT", seg.settings?.id || seg.id, nodeMap);
      totalNodeCount += nodeCount;
      return { ...seg, node_count: nodeCount };
    });

    if (totalNodeCount < 1) {
      totalNodeCount = 1;
    }

    // 2) Convert nodeCount => fraction => *100 => new .value
    const updated = segmentsWithCounts.map((seg) => {
      const ratio = seg.node_count / totalNodeCount;
      const newVal = ratio * 100;
      return { ...seg, value: newVal };
    });

    let totalData = wheelData.reduce((sum, s) => sum + s.data_value, 0);

    const finalSegments = updated.map((seg) => {
      const newDataValue = (seg.value / 100) * totalData * DATA_MULTIPLIER;
      return {
        ...seg,
        data_value: Math.max(1, Math.ceil(newDataValue)), // keep it integer
      };
    });

    if (!segmentsAreSame(finalSegments, wheelData)) {
      console.log(finalSegments, "Corr UPDATE", totalNodeCount);
      dispatch(setWheelSegments(finalSegments));
      dispatch(pushToHistoryAction());
    }
  };

  useEffect(() => {
    if (automaticResizing) {
      // requestAnimationFrame(() => {
      //   handleAutoResizeByNodeCount();
      // });
      handleAutoResizeByNodeCount();
    }
  }, [wheelData, automaticResizing]);

  // Find segment that exceeds character limit for specific tooltip
  const getSegmentWithExcessChars = () => {
    if (!hasCharLimitExceeded || !wheelData || wheelData.length === 0)
      return null;

    for (const segment of wheelData) {
      try {
        const nodeMap =
          typeof segment.nodes === "string"
            ? JSON.parse(segment.nodes)
            : segment.nodes;
        const charCount = countTextCharacters(nodeMap, "ROOT");

        if (charCount > charLimitInASegment) {
          return segment;
        }
      } catch (error) {
        console.error(
          "Error counting characters for segment:",
          segment.id,
          error
        );
      }
    }
    return null;
  };

  const segmentWithExcessChars = getSegmentWithExcessChars();

  const rightContent = [
    {
      title: "Feedback Form",
      icon: <FeedbackIcon />,
      tooltip: "Give Feedback",
      onClick: () => {
        setOpenFeedbackModal(true);
      },
    },

    {
      title: "View Wheel",
      icon: <View />,
      tooltip: "Preview",
      onClick:() => {
        // Wrap handleSaveWheel in a Promise to properly await it
          handleSaveWheel(false, () => {
            // Resolve when save is successful, then navigate
            nav(`/wheel/${id}`);
          });
      },
    },

    {
      title: "Save Wheel",
      tooltip:
        hasCharLimitExceeded && segmentWithExcessChars
          ? `Unable to save: Segment [${
              segmentWithExcessChars?.settings?.title || "Untitled"
            }] has exceeded it's character limit`
          : hasCharLimitExceeded
          ? "Cannot save: Character limit exceeded"
          : "Save",
      icon: <Save />,
      onClick: () => {
        // Wrap handleSaveWheel in a Promise to properly await it
        handleSaveWheel(true, () => {
          // Resolve when save is successful
          // nav(`/wheel/${id}`);
        });
      },
      isLoading: isWheelSaving,
      isAutoSaveError: isAutoSaveError,
      unsavedChanges: unsavedChanges,
      disabled: hasCharLimitExceeded,
    },
  ];

  return (
    <>
      <Styled.MainDiv>
        <WheelHeader
          rightContent={rightContent}
          wheelName={wheel_name}
          subtitle={sub_title}
          wheelId={id}
          setModalOpen={setModalOpen}
          setOnLeave={setOnLeave}
          onClickBeta={onClickBeta}
          onBroadCastPress={onBroadCastPress}
          showBroadCastButton={true}
          handleLogoClick={handleLogoClick}
          isEditScreen={isEditScreen}
        />
        <div style={{ display: "flex", height: "calc(100vh - 8vh)" }}>
          <Styled.MainContentArea>{children}</Styled.MainContentArea>
          <SideMenu />
        </div>
        <SocialFoxFeedbackForm
          open={openFeedbackModal}
          onClose={() => {
            setOpenFeedbackModal(false);
          }}
        />
      </Styled.MainDiv>
    </>
  );
}

export default WheelLayout;
